export const PACKAGE_NAME = 'jiraServicedeskQueuesAutomationMenu';
export const TEAM_NAME = 'jsm-ignition';
